



































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import AuthQuery from '~/mixins/AuthQuery';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';
import * as ConnectedAccountHelpers from '../../../helpers/connected-account-helpers';
import { IConnectedAccount } from '../../../types/gala-store';

@Component({
  components: {
    TwoFactorAuthInputPrompt,
  },
})
export default class SteamLinkedAccount extends Mixins(AuthQuery) {
  private showSteamLinkedAccount = process.env.showSteamLinkedAccount;

  steamLogo = require('@/assets/logos/steam.svg');

  @State(
    profile => {
      return (profile.user?.connectedAccounts || []).find(
        (connectedAccount: IConnectedAccount) =>
          connectedAccount.connectionName === 'steam',
      );
    },
    { namespace: 'profile' },
  )
  steamProfile?: IConnectedAccount;

  private steamData: IConnectedAccount | undefined;

  set steam(state: IConnectedAccount | undefined) {
    if (state) {
      this.steamData = {
        connectionName: 'steam',
        accountId: state.accountId,
      };
    } else {
      this.steamData = {
        connectionName: 'steam',
        accountId: '',
      };
    }
  }

  get steam() {
    if (this.steamData) {
      return this.steamData;
    } else if (this.steamProfile) {
      return this.steamProfile;
    } else {
      return {
        connectionName: 'steam',
        accountId: '',
      };
    }
  }

  async disconnectSteam() {
    await this.doAuthQuery(async totpToken => {
      await ConnectedAccountHelpers.disconnectAccount(
        {
          apolloClient: this.$apolloProvider.clients.defaultClient,
          setState: () => {
            this.steam = undefined;
          },
          refreshUser: () => {
            this.$store.dispatch('profile/refreshUser');
          },
        },
        {
          connectionName: 'steam',
          totpToken,
        },
      );
    }, TwoFaCheckpoint.accountModifications);
  }
}
